<template>
    <div class="vipAllocation-edit">
        <div class="content-top">
            <div class="title">大客户配置</div>
            <div class="line"></div>
            <div class="update_btn" @click="saveConfiguration">保存</div>
        </div>
        <div class="content-center">
            <div class="bottom-tab" style="padding-left: 21px;padding-bottom: 25px;">
                <div style="display: inline-block;" class="title">当前价格：</div>
                <span style="display: inline-block;" v-if="SetParam.priceAllocation == 1">标准价</span>
                <!-- <span style="display: inline-block;" v-if="SetParam.priceAllocation == 2">会员价</span> -->
                <!-- <span style="display: inline-block;" v-if="SetParam.priceAllocation == 3">自定义折扣</span> -->
                <span style="display: inline-block;" v-if="SetParam.priceAllocation == 4">二级产品价格</span>
                <span style="display: inline-block;" v-if="SetParam.priceAllocation == 5">服务定价</span>
            </div>
        </div>
        <div>
            <price-allocation
               v-if="showpriceSet"
               ref="priceAllocation"
               :current-param ="SetParam"
            ></price-allocation>
        </div>
    </div>
</template>

<script>
    import { enterpriseVipInfo,enterpriseVipInfoEdit,getCertificate} from "@/service/customerInformation";
    // import { enterpriseVipPriceQuiry } from "@/service/customerInformation";
    
    import priceAllocation from "./priceAllocation";
    export default {
        name: "vipAllocationEdit",
        components:{
            priceAllocation
        },
        data(){
            return{
                vipinfo:{},
                matchConfig:{},
                CertificateTypes:'',
                isShowCertificate:false,
                cerList:[],
                SetParam:{},
                showpriceSet:false
            }
        },
        methods:{
            // getCerTypes(){
            //     getCertificate().then((res)=> {
            //         if (res.Result != 1) {
            //             return this.$message.error(res.Message)
            //         }
            //         this.cerList=res.Data;
            //     })
            // },
            getVipInfo(){
                this.vipinfo = {};
                let companyId=Number(this.$route.query.companyId);
                let param = {
                    companyId:companyId
                }
                enterpriseVipInfo(param).then((res)=>{
                    if(res.Result==1) {
                        let data = res.Data || {};
                        this.vipinfo = data;
                        this.SetParam = data;
                        this.SetParam.priceAllocation = data.priceAllocation?data.priceAllocation:1;
                        this.SetParam.isshowTab = false;
                        this.showpriceSet =true;
                        this.$nextTick(() => {
                            this.$refs.priceAllocation.getSetParam()
                        })
                    }else {
                        this.$message.error(res.Message)
                    }
                })
            },
            confirmCer(){
                if (this.CertificateTypes) {
                    const selectedItem = this.cerList.find((item) => {
                        return item.id === this.CertificateTypes
                    })
                    let obj = {
                        certificateId: selectedItem.id,
                        certificateTypeName: selectedItem.name
                    }
                    this.vipinfo.certificateRequire.push(obj);
                    const arr = this.vipinfo.certificateRequire;
                    for(var i=0;i<arr.length;i++){
                        for(var j=i+1;j<arr.length;j++){
                            if(arr[i].certificateId == arr[j].certificateId){
                                arr.splice(j,1);
                                j--;
                                this.$message.warning("请勿重复添加证书");
                                return
                            }
                        }
                    }
                    this.vipinfo.certificateRequire = arr;
                    this.isShowCertificate = false;
                } else {
                    this.$message.warning("请选择证书")
                }
            },
            removecer(index){
                this.vipinfo.certificateRequire.splice(index, 1);
            },
            openaddCer(){
                this.isShowCertificate=true;
                this.getCerTypes();
            },
            //保存
            saveConfiguration(){
                let companyId=Number(this.$route.query.companyId);
                let param ={
                    // certificateRequireList:this.vipinfo.certificateRequire,
                    companyId:companyId,
                    // enterpriseVipConfId:this.vipinfo.id,
                    enterpriseVipConfId:this.vipinfo.enterpriseVipConfId,
                    // productBrandTagGrade:this.vipinfo.productBrandTagGrade,
                    // productBrandTagHands:this.vipinfo.productBrandTagHands,
                    // productBrandTagOriginal:this.vipinfo.productBrandTagOriginal,
                    // serviceTagGrade:this.vipinfo.serviceTagGrade,
                    // serviceTagHands:this.vipinfo.serviceTagHands,
                    priceAllocation:this.$refs.priceAllocation.form.pagingType?this.$refs.priceAllocation.form.pagingType:1,
                }
                console.log("param",param)
                enterpriseVipInfoEdit(param).then((res)=>{
                    if (res.Result != 1) {
                        return this.$message.error('获取失败请联系开发人员')
                    }
                    this.$message.success("保存成功")
                    this.getVipInfo()
                    // this.$emit('onChange',false);
                })
            },
            // 跳转企业大客户协议
            openRenewal() {
                let companyId=Number(this.$route.query.companyId);
                this.$router.push('/customer/contractedEnterprise?companyId='+ companyId+'&confId='+this.vipinfo.id)
            },
        },
        activated() {
            this.getVipInfo()
        }
    }
</script>

<style lang="scss">
    .vipAllocation-edit {
        .m-l-55{
            margin-left: 55px;
        }
        .flex{
            display: flex;
        }
        .content-top {
            position: relative;

            .title {
                font-size: 20px;
                font-weight: bold;
                color: #111111;
            }

            .line {
                margin-top: 14px;
                border-bottom: 2px solid #F5F7F9;
            }

            .update_btn {
                position: absolute;
                top: 0;
                right: 0;
                width: 100px;
                height: 30px;
                background: #2D8CEF;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                text-align: center;
                line-height: 30px;
                cursor: pointer;
            }
        }
        .content-center{
            margin-top: 20px;
            font-size: 16px;
            color: #666666;
            .xy_btn{
                width: 60px;
                height: 30px;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 30px;
                text-align: center;
                background: #2D8CEF;
                cursor: pointer;
                position: relative;
                margin-left: 22px;
                top: -4px;
            }
            .wdith-112{
                width: 112px;
            }
            .area-item{
                position: relative;
                display: inline-block;
                vertical-align: middle;
                line-height: 26px;
                background-color: rgba(45, 140, 239, 0.4);
                margin-right: 26px;
                color: #2D8CEF;
                /*width: 68px;*/
                padding: 0px 20px;
                height: 26px;
                text-align: center;
                font-size: 14px;
                &:hover{
                    cursor: pointer;
                    .icon-remove{
                        display: block;
                    }
                }
                .icon-remove{
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                    font-size: 14px;
                    color: #fff;
                    cursor: pointer;
                    display: none;
                }
            }
            .btn-add{
                position: relative;
                display: inline-block;
                vertical-align: middle;
                width: 68px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                border: 1px solid #2D8CEF;;
                background-color: #fff;
                box-sizing: border-box;
                cursor: pointer;
                font-size: 16px;
                color: #2D8CEF;
                &:hover{
                    background-color: #2D8CEF;
                    color: #fff;
                }
            }
            .mar-r-22{
                margin-right:22px;
            }
        }
    }
</style>
